<style lang="scss">
  @import "dashboard";
</style>

<script>
import Product from '../product-category-list/product-category-list'
import { CONSTANT } from '../../../utils/constant.js'
import bannerImages from '../../../data/banerImages'
import { BCarousel, BCarouselSlide } from 'bootstrap-vue'

export default {
  components: {
    'app-product': Product,
    'b-carousel': BCarousel,
    'b-carousel-slide': BCarouselSlide
  },

  data () {
    return {
      CONSTANT: CONSTANT,
      bannerImages: bannerImages.images
    }
  },

  computed: {
    selectedProductCategory: {
      get () {
        return this.$store.state.configuration.selectedProductCategory
      },
      set (value) {
        this.$store.dispatch('changeProductCategory', value)
      }
    }
  },

  mounted () {
    this.$store.commit('lightBoxloaderOn', false)
  },

  methods: {
    /**
     * This method will display the products
     * according to selected category
     * @param product
     */
    showProducts (product) {
      this.selectedProductCategory = product
    }
  }
}
</script>

<template>
  <div class="container p-0">
    <b-carousel
      id="image-carousel"
      :interval="3000"
      controls
      indicators
    >
      <b-carousel-slide
        v-for="(bannerImage,index) in bannerImages"
        :key="index"
      >
        <template v-slot:img>
          <img
            :src="require(`@/assets/images/${bannerImage.image}`)"
            class="d-block img-fluid w-100 img-height"
            alt="image slot"
          >
        </template>
      </b-carousel-slide>
    </b-carousel>
    <nav class="navbar navbar-expand-lg navbar-light p-0 justify-content-center cursor-pointer">
      <ul class="navbar-nav row navbar-component">
        <li
          v-for="(label, index) in CONSTANT.CONFIG.PRODUCT_NAVIGATION_LIST"
          :key="index"
          class="col-md-12 col-lg-4 col-sm-12 p-0 nav-item border"
        >
          <a
            :class="selectedProductCategory==label? 'nav-link active':'nav-link'"
            class="text-dark text-center dashboard-link"
            @click="showProducts(label)"
          >
            <h4 class="m-0">{{ label }}</h4>
          </a>
        </li>
      </ul>
    </nav>
    <app-product />
  </div>
</template>
